import styled from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import { useReportContext } from '../../context/DetailContext';
import { useEffect, useState } from 'react';
import { CaseInfo } from './data';
import { useNavigate, useParams } from 'react-router-dom';
import {
  AroundRealDealFilter,
  BasicInfoProps,
  HouseInfoProps,
  LandInfoProprs,
  RealDealFilter,
} from './data';
import DetailService from '../../service/detail';
import Summary from './components/summary/Summary';
import BasicInfo from './components/basicInfo/BasicInfo';
import BiddingHistory from './components/biddingHistory/BiddingHistory';
import BiddingMethodInfo from './components/biddingMethodInfo/BiddingMethodInfo';
import AfterBidInfo from './components/afterBidInfo/AfterBidInfo';
import BiddingInfo from './components/biddingInfo/BiddingInfo';
import ItemState from './components/ItemState/ItemState';
import { PAuctionAppraisalPrice } from './components/appraisalPrice/AppraisalPrice';
import { PTenantStatus } from './components/TenantStatus/TenantStatus';
import PRegisterStatus from './components/registerStatus/RegisterStatus';
import PriceAnalysis from './components/priceAnalysis/PriceAnalysis';
import AiRecommendation from './components/aiRecommendation/AiRecommendation';
import Menu from '../components/menu/Menu';
import PageToTop from './components/pageToTop';
import RelatedItemTab from './components/relatedItemTab';
import ScrollToTopButton from '../components/ScrollToTopButton';
import Loading from '../../func/components/loading/LoadingCircle';
import { NplCalculation } from '../../utils/nplAnalysis';
import { INplInfo } from '../../service/detail';
import NPLSummary from './components/nplAnalysis/nplSummary';
import OverView from './components/nplAnalysis/OverView';
import RealEstateStatus from './components/nplAnalysis/RealEstateStatus';
import SaleDateSimulation from './components/nplAnalysis/SaleDateSimulation';
import SeniorityDetails from './components/nplAnalysis/SeniorityDetails';
import ExpectedLoanPrincipal from './components/nplAnalysis/ExpectedLoanPrincipal';
import ExpectedInvestmentPeriod from './components/nplAnalysis/ExpectedInvestmentPeriod';
import ExpectedDividendAnalysis from './components/nplAnalysis/ExpectedDividendAnalysis';
import CostAnalysis from './components/nplAnalysis/CostAnalysis';
import ProfitAnalysis from './components/nplAnalysis/ProfitAnalysis';
import NavigationTab from './components/nplAnalysis/nplAnalysisNavigationTab';
import { userGradeType } from '../../utils/auth';
import { useModal } from '../../context/ModalContext';
import PAttachmentFile from './PAttachmentFile';
import AttachmentFileModal from './AttachmentFileModal';
import { PFileList } from '../../sidebar'
import Footer from '../components/footer/Footer';
import DetailOrNplTab from './components/nplAnalysis/DetailOrNplTab';

interface DataProps {
  address: string;
  appraisedprice: string;
  bid: string;
  caseno: string;
  court: string;
  img: string;
  minprice: string;
  saledate: string;
  type: string;
  unitno: string;
  viewgray: string;
  viewgray2: string;
  l_area: string;
  b_area: string;
  iidx: string;
  iidx2: number;
  bidprice: number;
  a_per: number;
  linkSet?: any;
  caseInfo: any;
}

interface fileProps {
  link: string;
  title: string;
}


const PAuctionDetail = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState('pAuction');
  const [loading, setLoading] = useState(false);
  const [iidx, setIidx] = useState<String | undefined>('');
  const [caseInfo, setCaseInfo] = useState<CaseInfo>();
  const [caseno, setCaseno] = useState('');
  const [imgList, setImgList] = useState([]);
  const [basicInfo, setBasicInfoData] = useState<BasicInfoProps>();
  const [landInfo, setLandInfo] = useState<LandInfoProprs>();
  const [houseInfo, setHouseInfo] = useState<HouseInfoProps>();
  const [landUsePlan, setLandUsePlan] = useState();
  const [saleInfo, setSaleInfoData] = useState();
  const [pRenterInfo, setPRenterInfo] = useState('');
  const [rentNote, setRentNote] = useState([]);
  const [registerStatus, setRegisterStatus] = useState();
  const [bidHistory, setBidHistory] = useState();
  const [bidMethod, setBidMethod] = useState();
  const [leaseinfo, setLeaseInfo] = useState();
  const [pAuctionAppraisalPriceInfo, setPAuctionAppraisalPriceInfo] =
    useState();
  const [link, setLink] = useState('');
  const [locationInfo, setLocationInfo] = useState('');
  const [appraisalevaluation, setAppraisalEvaluation] = useState('');
  const [realPriceData, setRealPriceData] = useState();
  const [nearRealPriceData, setNearRealPriceData] = useState();
  const [sameAddressItems, setSameAddressItems] = useState<DataProps[]>([]);
  const [sameAddressItems2, setSameAddressItems2] = useState<DataProps[]>([]);
  const [nearbyItemList1, setNearbyItemList1] = useState<DataProps[]>([]);
  const [nearbyItemList2, setNearbyItemList2] = useState<DataProps[]>([]);
  const [linkSet, setLinkSet] = useState();
  const [priceAnalysisData, setPriceAnalysisData] = useState();
  const [subHouseInfo, setSubHouseInfo] = useState(); //총괄표제부
  const [groupCategory, setGroupCategory] = useState(''); //그룹카테고리 //A7일 때만 업빌드 나옴
  const [attachmentFile, setAttachmentFile] = useState<fileProps[]>([]);
  const [showFileModal, setShowFileModal] = useState(false);
  const [warning, setWarning] = useState();
  const [sameItemAddr, setSameItemAddr] = useState('');
  const [openMenu, setOpenMenu] = useState(false);
  const [isTopButton, setIsTopButton] = useState(false);
  const [relatedItem, setRelatedItem] = useState();
  const [nplInfo, setNplInfo] = useState<INplInfo>();
  const [nplAnalysis, setNplAnalysis] = useState<NplCalculation>();
  const { number } = useParams();
//  const commonList = PFileList(linkSet);
  const {
    type,
    setType,
    itemType,
    setItemType,
    setLat,
    setLng,
    setBid,
    setGeom,
    setZoning,
  } = useReportContext();
  const [realDealFilter, setRealDealFilter] = useState<RealDealFilter>({
    iidx: Number(number) ?? 0,
    b_idx: 0,
    distance: 500,
    limit: 6,
    offset: 0,
  });
  const [aroundRealDealFilter, setAroundRealDealFilter] =
    useState<AroundRealDealFilter>({
      iidx: Number(number) ?? 0,
      b_idx: 0,
      distance: 500,
      limit: 6,
      offset: 0,
    });
  const [analysisModal, setAnalysisModal] = useState(false);
  const { modalDispatch } = useModal();

  async function getNplData(iidx: number) {
    try {
      setLoading(true);

      const nplInfo = await DetailService.getNplAnalysis(iidx);

      setNplAnalysis(
        new NplCalculation(
          Number(nplInfo.appraisedprice),
          Number(nplInfo.claimAmount),
          nplInfo.stats,
          nplInfo.ai,
          nplInfo.sale_date.map((el) => ({ ...el, price: Number(el.price) })),
          nplInfo.bondPrice,
          nplInfo.court,
          nplInfo.seniorInfo,
          nplInfo.is_company,
          nplInfo.marketPrc,
        ),
      );
      setNplInfo(nplInfo);
      setLoading(false);
    } catch (e) {
      console.error('getNplData', e);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (tab === 'npl' && iidx !== '' && !nplInfo) {
      getNplData(Number(iidx));
    }
  }, [tab, iidx, nplInfo]);

  /**총괄표제부에서 주용도지역인 객체의 건물명을 가져오는 함수 */
  const getOneNameWithSubHouseInfo = (arr: any[]): string | null => {
    const found = arr.find((item) => item.mainminorcodename === '주건축물');
    return found ? found.buildingname : '';
  };

  const getDetailData = async (iidx: number) => {
    setLoading(true);
    try {
      const res = await DetailService.detail(iidx);
      if (res.status === 'success') {
        setGroupCategory(res.data.info.group_category);
        setType(res.data.info.caseInfo.type);
        setItemType(res.data.houseInfo ? 'H' : 'L');
        setCaseInfo(res.data.info.caseInfo);
        setImgList(res.data.info.imgs);
        setHouseInfo(
          res.data.houseInfo
            ? res.data.houseInfo[0]
            : { approvaldate: 'nodata' },
        );
        setLandInfo(
          res.data.landInfo ? res.data.landInfo[0] : { address: 'nodata' },
        );
        if (res.data.mapInfo && res.data.mapInfo.length > 0) {
          setLat(res.data.mapInfo[0].lat);
          setLng(res.data.mapInfo[0].lng);
          const wkt = res.data.mapInfo[0].geom;
          const coordinates = wkt
            .replace('MULTIPOLYGON(((', '') // WKT 헤더 제거
            .replace(')))', '') // 마지막 괄호 제거
            .split(',') // 좌표 문자열 분리
            .map((coord: any) => {
              const [lng, lat] = coord.trim().split(' ').map(Number);
              return [lng, lat]; // 배열 형식으로 변환
            });
          setGeom(coordinates);
        }
        setBasicInfoData(res.data.info.loanInfo[0]);
        setCaseno(res.data.info.caseInfo.caseno);
        setBid(res.data.info.caseInfo.bid);
        setSaleInfoData(res.data.info.info);
        setAttachmentFile(res.data.info.file);
        setRelatedItem(res.data.listOfUnitno);
        setLinkSet(res.data.link);
        if (res.data.pauction && res.data.pauction.length > 0) {
          setPRenterInfo(res.data.pauction[0].registrationcertificatekey);
          setRegisterStatus(res.data.pauction[0].bidmethod);
          setBidMethod(res.data.pauction[0].bidinformation);
          setLeaseInfo(res.data.pauction[0].leaseinformation);
          setBidHistory(res.data.pauction[0].nearbyauctionstatistics);
          setPAuctionAppraisalPriceInfo(
            res.data.pauction[0].afterbiddingdelivery,
          );
          setLink(res.data.pauction[0].link);
          setLocationInfo(res.data.pauction[0].locationandusagestatus);
          setAppraisalEvaluation(res.data.pauction[0].appraisalevaluation);
        }
        setSubHouseInfo(res.data.subHouseInfo);
        setWarning(res.data.warning);
        setSameItemAddr(
          res.data.houseInfo
            ? res.data.subHouseInfo.length > 0
              ? (getOneNameWithSubHouseInfo(res.data.subHouseInfo) ?? '')
              : ''
            : res.data.info.caseInfo.iaddr,
        );
        if (res.data.houseInfo) {
          setZoning(res.data.landInfo[0].zoning_backup ?? '');
        }
      }
      setLoading(false);
    } catch (error: any) {
      if (error.response && error.response.data.message === 'jwt malformed') {
        // JWT가 잘못된 경우 로그인 페이지로 리디렉션
        alert('로그인이 필요합니다.');
        navigate('/login');
      } else {
        // 다른 오류 처리
        console.error('API 오류:', error);
      }
    }
  };

  const getUseStatus = async (iidx: number) => {
    try {
      const res = await DetailService.usestatus(iidx);
      setLandUsePlan(res.data);
    } catch (e) {
      console.log(e);
    }
  };

  const GetList = async (iidx: number) => {
    try {
      const res = await DetailService.nearbyItems(iidx);
      setSameAddressItems(res.data.list1);
      setSameAddressItems2(res.data.list2);
      setNearbyItemList1(res.data.list3);
      setNearbyItemList2(res.data.list4);
    } catch (e) {
      console.log(e);
    }
  };

  /** 시세분석 api */
  const GetPriceAnalysis = async (iidx: number) => {
    try {
      const res = await DetailService.priceAnalysis(iidx);
      setPriceAnalysisData(res.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    setIidx(number);
    getDetailData(Number(number));
    getUseStatus(Number(number));
    GetList(Number(number));
    GetPriceAnalysis(Number(number));
    setRealDealFilter({
      iidx: Number(number),
      b_idx: 0,
      distance: 500,
      limit: 6,
      offset: 0,
    });
    setAroundRealDealFilter({
      iidx: Number(number),
      b_idx: 0,
      distance: 500,
      limit: 6,
      offset: 0,
    });
  }, [number]);

  const plusAnalysisYN = () => {
    if (itemType === 'H') {
      // '단독주택'일 경우 또는 '주택'이면서 HOUSEINFO.USE가 '단독주택'일 경우
      const validCategories = [
        '임야',
        '대지',
        '단독주택',
        '도시형생활주택',
        '기타주거용건물',
        '다가구주택',
        '조립식주택',
      ];
      const isValidBasicCategory = validCategories.includes(
        basicInfo?.category ?? '',
      );

      if (basicInfo?.category === '임야' || basicInfo?.category === '대지') {
        return true;
      } else if (
        isValidBasicCategory &&
        houseInfo?.mainpurposecodename === '단독주택'
      ) {
        return true;
      } else {
        return false;
      }
    }

    if (itemType === 'L') {
      const validCategories = [
        '전',
        '답',
        '과수',
        '과수원',
        '농지',
        '임야',
        '대지',
        '대',
      ];
      const isValidBasicCategory = validCategories.includes(
        basicInfo?.category ?? '',
      );
      const isValidLandCategory = validCategories.includes(
        landInfo?.category ?? '',
      );

      return isValidBasicCategory && isValidLandCategory;
    }

    return false;
  };

  const GetRealDealPriceList = async (data: RealDealFilter) => {
    try {
      const { iidx, b_idx, distance, limit, offset } = data;
      const res = await DetailService.realDealPrice(
        iidx,
        b_idx,
        distance,
        limit,
        offset,
      );
      setRealPriceData(res.data);
    } catch (e) {
      console.log(e);
    }
  };

  const GetAroundRealDealPriceList = async (data: RealDealFilter) => {
    try {
      const { iidx, b_idx, distance, limit, offset } = data;
      const res = await DetailService.aroundRealDealPrice(
        iidx,
        b_idx,
        distance,
        limit,
        offset,
      );
      setNearRealPriceData(res.data);
    } catch (e) {
      console.log(e);
    }
  };
  //동일 물건 실거래가 조회
  useEffect(() => {
    if (tab === 'pAuction' && iidx !== '') {
      GetRealDealPriceList(realDealFilter);
    }
  }, [realDealFilter]);

  //인근 물건 실거래가 조회
  useEffect(() => {
    if (tab === 'pAuction' && iidx !== '') {
      GetAroundRealDealPriceList(aroundRealDealFilter);
    }
  }, [aroundRealDealFilter]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > 50) {
        setIsTopButton(true);
      } else {
        setIsTopButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

//   const [linkSet, setLinkSet] = useState({
//   buttonLink: {
//     propertyStat: '',
//     appraisal: '',
//     buildingRegister: '',
//     landRegister: '',
//     assetDetail: '',
//   }
// });

  return (
    <Container>
      <ScrollToTopButton />
      <PageTop logo setOpenMenu={setOpenMenu} isCloseButton />
      <DetailOrNplTab tab={tab} setTab={setTab} modalDispatch={modalDispatch} />
      {relatedItem && (
        <RelatedItemTab relatedItem={relatedItem} number={number} />
      )}
      <CaseNumberBox>
        <span>
          {caseInfo?.caseno}
          {caseInfo?.type == 'p'
            ? '-' + caseInfo?.itemno
            : caseInfo?.itemno.replace(/[^0-9]/g, '')
              ? ' (' + caseInfo?.itemno.replace(/[^0-9]/g, '') + ')'
              : ' (1)'}
        </span>
        <CourtName>[{caseInfo?.branchName}]</CourtName>
      </CaseNumberBox>
      {tab === 'pAuction' &&
        (loading ? (
          <Loading />
        ) : (
          <Inner>
            {caseInfo && (
              <Summary
                caseInfo={caseInfo}
                imgList={imgList}
                basicInfo={basicInfo}
                realPriceData={realPriceData}
              />
            )}

            {basicInfo && <BasicInfo data={basicInfo} linkSet={linkSet} />}
            {bidHistory && <BiddingInfo bidHistory={bidHistory} />}
            {bidHistory && <BiddingHistory bidHistory={bidHistory} />}
            {bidMethod && <BiddingMethodInfo bidMethod={bidMethod} />}
            {leaseinfo && <AfterBidInfo leaseinformation={leaseinfo} />}
            
            {/* 감정가 */}
            {pAuctionAppraisalPriceInfo && (
              <PAuctionAppraisalPrice
                data={pAuctionAppraisalPriceInfo}
                link={link}
                linkSet={linkSet}
              />
            )}
            {/* 물건현황 */}
            {landInfo &&
              houseInfo &&
              landUsePlan &&          
              (
                <ItemState
                  subHouseInfo={subHouseInfo}
                  landInfo={landInfo}
                  houseInfo={houseInfo}
                  landUsePlan={landUsePlan}
                  appraisalevaluation={appraisalevaluation}
                  locationInfo={locationInfo}
                  groupCategory={groupCategory}
                  caseInfo={caseInfo}
                  linkSet={linkSet}
                  setShowFileModal={setShowFileModal}
                />
              )}
            {/* 임차인현황 */}
            {pRenterInfo && rentNote && (
              <PTenantStatus pRenterInfo={pRenterInfo} rentNote={rentNote} />
            )}
            {/* 등기부 현황 */}
            {registerStatus && (
              <PRegisterStatus
                registerStatus={registerStatus}
                warning={warning}
                linkSet={linkSet}
              />
            )}
            {/* 가격분석 */}
            {priceAnalysisData && (
              <PriceAnalysis
                realPriceData={realPriceData}
                nearRealPriceData={nearRealPriceData}
                priceAnalysisData={priceAnalysisData}
                realDealFilter={realDealFilter}
                setRealDealFilter={setRealDealFilter}
                aroundRealDealFilter={aroundRealDealFilter}
                setAroundRealDealFilter={setAroundRealDealFilter}
                sameItemAddr={sameItemAddr}
                linkSet={linkSet}
                caseInfo={caseInfo}
              />
            )}
            {/* 첨부파일 */}
            <PAttachmentFile
              linkSet={linkSet}
              setShowFileModal={setShowFileModal}
            />
            {showFileModal && (
            <AttachmentFileModal
            showFileModal={showFileModal}
            setShowFileModal={setShowFileModal}
            attachmentFile={attachmentFile}
            linkSet={linkSet}
            />
          )}
            {/* 동일 지번 진행 물건 */}
            {sameAddressItems.length > 0 && (
              <AiRecommendation
                title="동일 지번 진행 물건"
                data={sameAddressItems}
                status="진행"
              />
            )}
            {/*  동일 지번 낙찰 물건 */}
            {sameAddressItems2.length > 0 && (
              <AiRecommendation
                title="동일 지번 낙찰 물건"
                data={sameAddressItems2}
                status="낙찰"
              />
            )}
            {/* 인근 반경 진행 물건 */}
            {nearbyItemList1.length > 0 && (
              <AiRecommendation
                title="인근 반경 진행 물건"
                data={nearbyItemList1}
                status="진행"
              />
            )}
            {/*  인근 반경 낙찰 물건 */}
            {nearbyItemList2.length > 0 && (
              <AiRecommendation
                title="인근 반경 낙찰 물건"
                data={nearbyItemList2}
                status="낙찰"
              />
            )}
          </Inner>
        ))}
      {tab === 'npl' &&
        (loading ? (
          <Loading />
        ) : (
          <ReportContainer id="printable">
            <NavigationTab />
            {caseInfo && nplAnalysis && nplInfo && (
              <ReportDetail>
                {/* NPL 분석요약 */}
                <div id="NPL 분석요약">
                  <NPLSummary
                    caseInfo={caseInfo}
                    summary={nplAnalysis.getSummary()}
                    info={nplInfo}
                  />
                </div>

                {/* 채권 내 물건별 개요 */}
                <div id="채권내 물건별 개요">
                  <OverView itemList={nplInfo.itemList} />
                </div>

                {/* 부동산 현황 */}
                <div id="부동산현황">
                  <RealEstateStatus info={nplInfo} />
                </div>

                {/* 매각기일 시뮬레이션 */}
                <div id="매각기일 시뮬레이션">
                  <SaleDateSimulation
                    bidDateSimulation={nplAnalysis.getBidDateSimul()}
                  />
                </div>

                {/* 선순위 내역 */}
                <div id="선순위내역">
                  <SeniorityDetails
                    seniorityDetails={nplAnalysis.getSeniorInfo()}
                  />
                </div>

                {/* 예상 대출원리금 */}
                <div id="예상대출원리금">
                  <ExpectedLoanPrincipal
                    expectedLoanPrincipal={nplAnalysis.getExpectedLoan()}
                  />
                </div>

                {/* 예상 투자기간 */}
                <div id="예상투자기간">
                  <ExpectedInvestmentPeriod
                    expectedInvestmentPeriod={nplAnalysis.getExpectedInvestmentDays()}
                  />
                </div>

                {/* 예상 배당분석 */}
                <div id="예상배당분석">
                  <ExpectedDividendAnalysis
                    expectedDividendAnalysis={nplAnalysis.getExpectedDividendAnalysis()}
                  />
                </div>

                {/* 비용 분석 */}
                <div id="비용분석">
                  <CostAnalysis
                    profitAnalysis={nplAnalysis.getProfitAnalysis()}
                  />
                </div>

                {/* 수익 분석 */}
                <div id="수익분석">
                  <ProfitAnalysis
                    revenueAnalysis={nplAnalysis.getRevenueAnalysis()}
                  />
                </div>
              </ReportDetail>
            )}
          </ReportContainer>
        ))}
      {openMenu && <Menu page="main" setOpenMenu={setOpenMenu} />}
      <Footer/>
    </Container>
  );
};

export default PAuctionDetail;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
`;
const Inner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #f0f0f0;
`;

const CaseNumberBox = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 700;
  color: white;
  background-color: #000;
`;
const CourtName = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.64);
`;

const TabBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
`;
const TabButton = styled.span<{ active: boolean }>`
  flex: 1;
  padding: 10px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => (props.active ? '#222' : '#989BA2')};
  border-bottom: ${(props) => (props.active ? '2px solid #222' : 'none')};
  cursor: pointer;
`;

const ReportContainer = styled.div`
  width: 100%;
  background-color: #fff;
  font-family: Spoqa Han Sans Neo;
  position: relative;
  display: flex;
  flex-direction: column;
`;
const ReportDetail = styled.div`
  width: 100%;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
`;